import {Injectable} from '@angular/core';
import {Language} from '../interfaces/shared';
import {StorageService} from './storage.service';
import {arabicDictionary, englishDictionary} from '../static/language-pack';
import {ActionSheetController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public globalDictionary: any;
  public currentLanguage: Language;

  constructor(
    private storage: StorageService,
    private actionSheetCtrl: ActionSheetController
  ) {
    this.currentLanguage = Language.english;
    this.globalDictionary = JSON.parse(englishDictionary);
    this.triggerCheckLanguage();
  }

  async triggerCheckLanguage() {
    const language = await this.storage.getValue('app_language') as Language | null;
    if (language !== null) {
      this.currentLanguage = language;
      if (language === Language.arabic) {
        this.globalDictionary = JSON.parse(arabicDictionary);
      } else {
        this.globalDictionary = JSON.parse(englishDictionary);
      }
    } else {
      this.currentLanguage = Language.english;
      this.globalDictionary = JSON.parse(englishDictionary);
    }
  }

  async setAppLanguage(newLanguage: Language) {
    await this.storage.setValue('app_language', newLanguage);
    await this.triggerCheckLanguage();
  }

  async changeLanguageSheet() {
    // Use different approach for English and Arabic
    const title = this.currentLanguage === Language.english ? 
      'Change Language' :  // Normal LTR for English
      '\u200Fتغيير اللغة';  // Only RTL mark for Arabic (U+200F)
    const dynamicButtons = [];
    if (this.currentLanguage === Language.english) {
      dynamicButtons.push(
        {
          text: 'العربية',
          icon: 'arrow-back-outline',
          handler: () => {
            this.setAppLanguage(Language.arabic);
          }
        }
      );
      dynamicButtons.push(
        {
          text: 'Cancel',
          icon: 'close',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      );
    } else {
      dynamicButtons.push(
        {
          text: 'English',
          icon: 'arrow-forward-outline',
          handler: () => {
            this.setAppLanguage(Language.english);
          }
        }
      );
      dynamicButtons.push(
        {
          text: '\u200Fإلغاء',  // Adding RTL mark to ensure Arabic text displays correctly
          icon: 'close',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      );
    }
    const actionSheet = await this.actionSheetCtrl.create({
      header: title,
      buttons: dynamicButtons,
      cssClass: this.currentLanguage === Language.arabic ? 'rtl-action-sheet' : ''
    });
    await actionSheet.present();
  }
}
